import React from "react"
import classNames from "classnames"
import { CurrentTapType } from "../Disputes"
import { useTranslation } from "react-i18next"

export const DisputeStatus = ({ disputeStatus }: { disputeStatus: CurrentTapType }) => {
  const { t } = useTranslation()

  return (
    <span
      className={classNames(
        disputeStatus === CurrentTapType.pending
          ? "bg-cyan-30 text-cyan"
          : disputeStatus === CurrentTapType.solved
          ? "text-success bg-success-30"
          : disputeStatus === CurrentTapType.rejected
          ? "bg-danger-30 text-danger"
          : disputeStatus === CurrentTapType.inProgress
          ? "bg-primary-30 text-primary"
          : "bg-primary-30",
        "px-2 py-1 rounded fw-semibold font-size-12"
      )}
    >
      {t(disputeStatus)}
    </span>
  )
}
